import apiCommonCategory from "@/api/common-category";
import {post} from "@/utils/request";

export default class apiBkBookChoose extends apiCommonCategory{
  static module = 'bk_book_choose'
  static async save(showId, title){
    return post('/home/bk_book_choose/save', {showId, title})
  }

  static async listDel(ids){
    return post('/home/bk_book_choose/listDel', {ids})
  }

  static async importBook(fileUrl, id){
    return post('/home/bk_book_choose/importBook', {fileUrl, id})
  }

  static async setRead(id, isAll=0){
    return post('/home/bk_book_choose/setRead', {id, isAll})
  }

  static async addCartFromDetail(ids) {
    return post('/home/bk_book_choose/addCartFromDetail', {ids})
  }

  static async getDetailList(id, page=1, pageSize=100){
    return post('/home/bk_book_choose/getDetailList', {id, page, pageSize})
  }
}
